// Extensions' registration (docs/features/extensions.md): an extension's pane in its own window (`extpane`,
// `pane:<ext>/<id>`, opened from its session or stream menu) and the wire kind `extension` (subscribe · action ·
// view · follow → list · ui · remove · feed · result · notify), handed to the Extensions store through the link.
// The Agent pane registers with the session's panes (windows/session/panes/agent).
import { registerWindow } from '../core/windows.js'
import { registerWire } from '../core/wire.js'

registerWindow('extpane', { module: () => import('./extpane.js'), key: (a, key) => `extpane-${key || 'mac'}-${a?.ext || ''}-${a?.id || ''}`, title: () => 'Pane', place: ['session', 'trailing'] })
registerWire('extension', (link, payload, m) => { if (m) link.onExtension?.(m) })
